import SwipeOut from './SwipeOut';
export default SwipeOut;